<app-side-bar [sidebarId]="sideBarId()">
    <!-- Sidebar Header Template: workspace selector (always visible) -->
    <ng-template #sidebarHeader>
        <app-workspace class="workspace-selector"></app-workspace>
    </ng-template>

    <!-- Sidebar Footer Template: user avatar + menu (hidden in sub-views) -->
    <ng-template #sidebarFooter>
        <div class="p-2 mt-auto border">
            <ul [class.hidden]="!isUserMenuOpen" [class.animate-slidedown]="isUserMenuOpen"
                class="list-none m-0 animate-duration-300 overflow-hidden gap-2">
                @if(ENV.enableSubscription && currentUser.role == USER_ROLE.SUPER_ADMIN){
                <li>
                    <a [routerLink]="'/pricing'" routerLinkActive="bg-arena-blue-100"
                        [routerLinkActiveOptions]="{exact: false}"
                        class="flex items-center cursor-pointer p-3 gap-2 rounded-base item-hover transition-colors duration-1500 text-sm">
                        <i [innerHTML]="SVG.BILLING_PAYMENTS | sanitizeHtml"></i>
                        <span class="font-medium leading-tight">{{'Billing & payments' | textCase}}</span>
                    </a>
                </li>
                }
                <li>
                    <a [routerLink]="subscriptionState.hasSubscriptionEnded() ? null : '/profile'"
                        routerLinkActive="bg-arena-blue-100" [routerLinkActiveOptions]="{exact: false}"
                        class="flex items-center p-3 gap-2 rounded-base transition-colors duration-1500 text-sm"
                        [ngClass]="subscriptionState.hasSubscriptionEnded() ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'cursor-pointer item-hover'"
                        (click)="subscriptionState.hasSubscriptionEnded() ? $event.preventDefault() : null">
                        <i [innerHTML]="SVG.PROFILE | sanitizeHtml"></i>
                        <span class="font-medium leading-tight">{{'Profile' | textCase}}</span>
                        @if(subscriptionState.hasSubscriptionEnded()) {
                        <i class="pi pi-lock text-surface-500 dark:text-surface-400 ml-auto"
                            [style.font-size]="'0.75rem'"></i>
                        }
                    </a>
                </li>
                <li *ngIf="canSeeSettings">
                    <a [routerLink]="subscriptionState.hasSubscriptionEnded() ? null : '/settings'"
                        (click)="subscriptionState.hasSubscriptionEnded() ? $event.preventDefault() : openSettings()"
                        routerLinkActive="bg-arena-blue-100" [routerLinkActiveOptions]="{exact: false}"
                        class="flex items-center p-3 gap-2 rounded-base transition-colors duration-1500 text-sm"
                        [ngClass]="subscriptionState.hasSubscriptionEnded() ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'cursor-pointer item-hover'">
                        <i [innerHTML]="SVG.SETTINGS | sanitizeHtml"></i>
                        <span class="font-medium leading-tight">{{'Settings' | textCase}}</span>
                        @if(subscriptionState.hasSubscriptionEnded()) {
                        <i class="pi pi-lock text-surface-500 dark:text-surface-400 ml-auto"
                            [style.font-size]="'0.75rem'"></i>
                        }
                    </a>
                </li>
                <li>
                    <div (click)="signOut()"
                        class="flex items-center cursor-pointer p-3 gap-2 item-hover transition-colors duration-1500 text-sm">
                        <i [innerHTML]="SVG.SIGN_OUT | sanitizeHtml"></i>
                        <span class="font-medium leading-tight">{{'Sign Out' | textCase}}</span>
                    </div>
                </li>
            </ul>
            <div (click)="toggleUserMenu()"
                class="flex items-center cursor-pointer p-2 gap-2 text-surface-900 dark:text-surface-0 hover: transition-colors duration-150">
                <p-avatar [image]="currentUser | userAvatar" class="header-avatar" shape="circle" severity="success" />
                <span class="font-medium text-sm leading-tight">{{currentUser | fullName}}</span>
                <i [class.pi-angle-up]="!isUserMenuOpen" [class.pi-angle-down]="isUserMenuOpen"
                    class="pi text-sm! leading-none! text-surface-500 dark:text-surface-400 ml-auto"></i>
            </div>
        </div>
    </ng-template>

</app-side-bar>

<!-- Subscription Ended Dialog -->
